<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $t('messages.school_year'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="flex flex-col mt-5">
            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                <div
                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                >
                    <table class="min-w-full divide-y divide-gray-200">
                        <thead>
                            <tr>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.name') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.date') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    {{ $t('messages.syllabus') }}
                                </th>
                                <th
                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                >
                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                v-for="(school_year, index) in school_years.data"
                                :key="index"
                            >
                                <td
                                    class="max-w-sm truncate px-6 py-4 whitespace-nowrap text-sm leading-5 font-medium text-gray-900"
                                >
                                    {{ school_year.year_range }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ school_year.dates_range }}
                                </td>
                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                    {{ school_year.syllabus_name }}
                                </td>
                                <td
                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1"
                                >
                                    <InertiaSquareLinkButton action="show" :href="school_year.links.show" />
                                    <InertiaSquareLinkButton action="edit" :href="school_year.links.edit" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="school_years" />
        </template>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import InertiaSquareLinkButton from '@/components/InertiaSquareLinkButton.vue';

export default {
    components: {
        PanelPage,
        InertiaPagination,
        InertiaSquareLinkButton,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'school_years'],
    data() {
        return {};
    },
    methods: {},
};
</script>
